import React, { useContext } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import Logo from "../../assets/logo.png";
import { WebsiteContext } from "../../context/AppContext";
import "../../styles/navBar.css";

const NavBarComponent = () => {
  const { isMobileView } = useContext(WebsiteContext);
  const navigate = useNavigate();

  const handleHomeClick = () => {
    navigate("/");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleBookClick = () => {
    navigate("/book-now");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <motion.header
      className={isMobileView ? "navbar_container_mobile" : "navbar_container"}
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
    >
      <div className="navbar_left" onClick={handleHomeClick}>
        <img src={Logo} alt="Covai Travels Logo" className="nav_logo" />
        <h1 className="nav_brand_text">SSS COVAI TRAVEL'S</h1>
      </div>

      <div className="navbar_right">
        <motion.button
          className="nav_cta_btn"
          onClick={handleBookClick}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          Book Ride
        </motion.button>
      </div>
    </motion.header>
  );
};

export default NavBarComponent;
